import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, Slide, AppBar, Toolbar, Typography, IconButton } from '@mui/material/';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';

const RenderFile = props => {
  const { openDialog = false, url, close } = props;
  const classes = useStyles();
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const onCloseDialog = () => {
    close();
  };
  return (
    <Dialog fullScreen open={openDialog} onClose={onCloseDialog} disableEnforceFocus TransitionComponent={Transition}>
      <AppBar position="static">
        <Toolbar>
          <Typography color="inherit" className={classes.flex} />

          <IconButton onClick={onCloseDialog} color="inherit" size="large">
            <ExitToAppOutlinedIcon />
            <Typography color="inherit" className={classes.textTitle}>
              Cerrar
            </Typography>
          </IconButton>
        </Toolbar>
      </AppBar>

      <div className={classes.containerIframe}>
        <iframe className={classes.responsiveIframe} src={url} title="pdf-recipe" 
          onError={(e) => console.log("Error loading PDF:", e)}
        />
      </div>
    </Dialog>
  );
};
export default RenderFile;

const useStyles = makeStyles(() => ({
  containerIframe: {
    position: 'relative',
    width: '100%',
    overflow: 'hidden',
    paddingTop: '100%',
  },
  responsiveIframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: '100%',
    height: '100%',
    border: 'none',
  },
  appBar: {
    background: '#fff',
  },
  flex: {
    flexGrow: 1,
  },
}));
